import React from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//tabla y card components
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//iconos
import { Assignment, Visibility } from '@material-ui/icons';

//modal
import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';

//servicios
import { Link } from 'react-router-dom';
import { currency } from 'hooks/Pipe';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  pills: {
    color: 'white',
    padding: '5px 8px 5px 8px',
    borderRadius: '10px',
    cursor: 'pointer'
  },
  icon: {
    fontSize: '20px',
    cursor: 'pointer',
    marginLeft: '5px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Fec. Programación', accessor: 'program_date', width: 170 },
  { Header: 'Nombre Vehiculo', accessor: 'vehicle_name' },
  { Header: 'Placa Vehiculo', accessor: 'vehicle_code', width: 150 },
  { Header: 'Año Vehiculo', accessor: 'vehicle_year', width: 120 },
  { Header: 'Zona Vehiculo', accessor: 'vehicle_zone_description', width: 130 },
  { Header: 'Nombre Conductor', accessor: 'manager_name' },
  { Header: 'DNI Conductor', accessor: 'manager_code', width: 140 },
  { Header: 'Lic. Conductor', accessor: 'manager_driver_license', width: 130 },
  { Header: 'Monto total', accessor: 'total_amount', width: 130 },
  { Header: 'Ord. totales', accessor: 'total_orders', width: 130 },
  { Header: 'Cli. totales', accessor: 'total_customers', width: 130 },
  { Header: 'Estado', accessor: 'state', width: 100 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function ProgAnalysiss(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();

  const { analysisData, dataLoading} = props

  return (
    <>
      <Toasty action={notify} />
      <Card>
        <CardHeader icon>
          <CardIcon pointer="true" color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Listado de análisis de programación {dataLoading && <LoadingSpinner />}</h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            excelName="Jornada-de-jefes"
            formatDate="DD-MM-YYYY"
            defaultWidth={1300}
            columns={columns}
            data={analysisData.map((item, i) => {
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <AllowedGuard permission={ConstantPermissions.REPORT_PROGRAM_ANALYSIS_SHOW}>
                      <Button justIcon round simple color={props.themeContext.buttonColorWarning}>
                        <Link to={`${item.id}`}>
                          <Visibility />
                        </Link>
                      </Button>
                    </AllowedGuard>
                  </div>
                ),
                program_date: item.program_date,
                total_amount: currency(item.total_amount),                
                total_orders: item.total_orders,
                total_customers: item.total_customers,
                state: item.state === 'A' ? 'Activo' : 'Inactivo',
                vehicle_code: item.vehicle?.code,
                vehicle_name: item.vehicle?.name,
                vehicle_year: item.vehicle?.year,
                vehicle_zone_description: item.vehicle?.zone?.description,

                manager_code: item.manager?.code,
                manager_name: item.manager?.name,
                manager_driver_license: item.manager?.driver_license,
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
